import { keepPreviousData, useQuery } from '@tanstack/react-query'

import type { GetConsultationsQuery } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches consultations with optional filters. Pass `remote: true` for the remote queue. */
export function useListConsultations(params?: GetConsultationsQuery & { enabled?: boolean }) {
  const api = useOsApi()
  const { enabled, ...query } = params ?? {}

  return useQuery({
    queryKey: ['consultations', query],
    queryFn: async () => {
      const response = await api.get('/consultations', { query })
      if (!response.success) throw new Error(response.error.message)
      return response.data.consultations
    },
    placeholderData: keepPreviousData,
    enabled,
  })
}
